import * as ActionApp from '../../App/Store/AppAction';
import * as ActionAuth from '../Store/AuthAction';
import * as ActionsComponent from '../../App/Store/ComponentAction';
import * as Selector from '../Selector/AuthSelector';
import * as SelectorAuth from '../../Auth/Selector/AuthSelector';
import * as SelectorConfig from '../../App/Selector/AppSelector';

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { FormattedMessage } from 'react-intl';
import React from 'react';
import axios from 'axios';
import { getCommonConfigHeader } from '../../App/Saga/AppSaga';
import history from '../../../App/History';
import { toast } from 'react-toastify';

let toastMessage;

export function* loginProcess() {
  yield put(ActionsComponent.processLoading(true));
  try {
    const API_URL = yield select(SelectorConfig.makeBaseAPISelector());
    const usernameLogin = yield select(Selector.makeUsernameSelector());
    const passwordLogin = yield select(Selector.makePasswordSelector());
    const { data } = yield call(axios.post, `${API_URL}/auth/login`, {
      username: usernameLogin,
      password: passwordLogin,
    });
    localStorage.setItem('authToken', JSON.stringify(data));
    yield put(ActionAuth.setLoginTokenData(data));
    history.push('/');
    toastMessage = (
      <span className="capitalFirst">
        <FormattedMessage id="loginSuccess" />
      </span>
    );
    toast.success(toastMessage, {
      className: 'toastSuccessBackground',
    });
  } catch (error) {
    if (error.response) {
      toastMessage = (
        <span className="capitalFirst">
          <FormattedMessage id={'unknownError'} />
        </span>
      );
    } else {
      toastMessage = (
        <span className="capitalFirst">
          <FormattedMessage id={'unknownError'} />
        </span>
      );
    }
    toast.error(toastMessage);
  }
  yield put(ActionsComponent.processLoading(false));
}

export function* renewTokenProcess(action) {
  try {
    const API_URL = yield select(SelectorConfig.makeBaseAPISelector());
    const config = yield call(getCommonConfigHeader);
    yield put(ActionsComponent.processLoading(true));
    const { data } = yield call(
      axios.get,
      `${API_URL}/auth/token/refresh`,
      config
    );
    yield put(ActionsComponent.processLoading(false));
    yield put(ActionAuth.setLoginTokenData(data));
    if (action.lastAction && action.lastAction.actionData) {
      yield put(action.lastAction.actionData);
    } else {
      yield put(ActionsComponent.reset());
    }
  } catch (error) {
    toastMessage = (
      <span className="capitalFirst">
        <FormattedMessage id={'sessionExpired'} />
      </span>
    );
    yield put(ActionAuth.logout());
    history.push('/login');
    toast.error(toastMessage);
    yield put(ActionsComponent.processLoading(false));
  }
}

export function* changePasswordProcess(action) {
  try {
    const API_URL = yield select(SelectorConfig.makeBaseAPISelector());
    const config = yield call(getCommonConfigHeader);
    const oldpassword = yield select(
      SelectorAuth.makeChangePasswordOldSelector()
    );
    const newpassword = yield select(
      SelectorAuth.makeChangePasswordNewSelector()
    );

    yield put(ActionsComponent.processLoading(true));
    yield call(
      axios.put,
      `${API_URL}/auth/changepassword`,
      {
        oldpassword,
        newpassword,
      },
      config
    );
    yield put(ActionAuth.logout());
    yield put(ActionsComponent.processLoading(false));
    yield put(ActionsComponent.openModal('ChangePassword'));
    toastMessage = (
      <span className="capitalFirst">
        <FormattedMessage id="changePasswordSuccess" />
      </span>
    );
    toast.success(toastMessage, {
      className: 'toastSuccessBackground',
    });
    history.push('/login');
  } catch (error) {
    yield put(ActionApp.handleError(action, error));
    yield put(ActionsComponent.processLoading(false));
  }
}

export function* login() {
  yield takeLatest('SUBMIT_LOGIN_REQUESTED', loginProcess);
}
export function* renewToken() {
  yield takeLatest('RENEW_TOKEN', renewTokenProcess);
}
export function* changePasswordAction() {
  yield takeLatest('CHANGE_PASSWORD_REQUESTED', changePasswordProcess);
}
